import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

const index = () => import(/* webpackChunkName: "layout" */ '../views/index/index.vue')
const AboutUs = () => import(/* webpackChunkName: "about-us" */ '../views/index/aboutUs/AboutUs.vue')
const NewsInformation = () => import(/* webpackChunkName: "news" */ '../views/index/newsInfomation/NewsInformation.vue')
const recruit = () => import(/* webpackChunkName: "recruit" */ '../views/index/recruit/recruit.vue')
const Homepage = () => import(/* webpackChunkName: "homepage" */ '../views/index/homePage/HomePage.vue')
const ProductDetails = () => import(/* webpackChunkName: "product-details" */ '../views/index/productDetails/productDetails.vue')
const ScanList = () => import(/* webpackChunkName: "scan-list" */ '../views/index/scanList/scanList.vue')
const NewsInformationDetail = () => import(/* webpackChunkName: "news-detail" */ '../views/index/NewsInformationDetail/NewsInformationDetail.vue')
const Login = () => import(/* webpackChunkName: "login" */ '../views/index/Login/Login.vue')
const editNews = () => import(/* webpackChunkName: "edit-news" */ '../views/index/editNews/editNews.vue')
const slideShow = () => import(/* webpackChunkName: "slide-show" */ '../views/slideShow/slideShow.vue')
const slideShowDetail = () => import(/* webpackChunkName: "slide-show-detail" */ '../views/slideShowDetail/slideShowDetail.vue')
const orderConfirm = () => import(/* webpackChunkName: "shop-order-confirm" */ '../views/index/shop/orderConfirm.vue')
const productList = () => import(/* webpackChunkName: "shop-product-list" */ '../views/index/shop/productList.vue')
const productDetail = () => import(/* webpackChunkName: "shop-product-detail" */ '../views/index/shop/productDetail.vue')
const paymentSuccess = () => import(/* webpackChunkName: "shop-payment-success" */ '../views/index/shop/paymentSuccess.vue')
const paymentFailed = () => import(/* webpackChunkName: "shop-payment-failed" */ '../views/index/shop/paymentFailed.vue')
const contactUs = () => import(/* webpackChunkName: "contact-us" */ '../views/index/contactUs/contactUs.vue')
const download = () => import(/* webpackChunkName: "download" */ '../views/index/download/download.vue')
 
Vue.use(VueRouter)

const routes:Array<RouteConfig> = [
  {
    path: '/index',
    redirect:'/homepage'
  },
  {
    path: '/',
    redirect:'/homepage'
  },
  {
    path: '/index',
    name: 'index',
    meta:{
      title:'首页'
    },
    component:index,
    children: [
      {
        path: '/aboutUs',
        name: 'AboutUs',
        component:AboutUs,
        meta:{
          title:"关于我们"
        },
      },
      {
        path: '/newsInformation',
        name: 'NewsInformation',
        component:NewsInformation,

      }, {
        path: '/NewsInformationDetail',
        name: 'NewsInformationDetail',
        component:NewsInformationDetail,

      },
      {
        path: '/productDetails',
        name: 'ProductDetails',
        component:ProductDetails
      },
      {
        path: '/scanList',
        name: 'ScanList',
        component:ScanList
      },
      {
        path: '/recruit',
        name: 'recruit',
        component:recruit
      },
      {
        path: '/homepage',
        name: 'Homepage',
        component:Homepage
      },
      {
        path: '/shop/orderConfirm',
        name: 'OrderConfirm',
        component:orderConfirm,
      },
      {
        path: '/shop/productList',
        name: 'ProductList',
        component:productList,
        meta:{
          title:'商品列表'
        },
      },
      {
        path: '/shop/productDetail/:productId',
        name: 'ProductDetail',
        component:productDetail,
        meta:{
          title:'商品详情'
        },
      },
      {
        path: '/shop/paymentSuccess',
        name: 'PaymentSuccess',
        component:paymentSuccess,
        meta:{
          title:'支付成功'
        },
      },
      {
        path: '/shop/paymentFailed',
        name: 'PaymentFailed',
        component:paymentFailed,
        meta:{
          title:'支付失败'
        },
      },

      {
        path: '/contactUs',
        name: 'contactUs',
        component:contactUs,
        meta:{
          title:'联系我们'
        },
      },
      {
        path: '/download',
        name: 'download',
        component:download,
        meta:{
          title:'软件下载'
        },
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component:Login
  },
  {
    path: '/editNews',
    name: 'editNews',
    component:editNews
  },{
    path: '/slideShow',
    name: 'slideShow',
    component:slideShow
  },{
    path: '/slideShowDetail',
    name: 'slideShowDetail',
    component:slideShowDetail
  },

]

const router = new VueRouter({
  routes,
  mode:"hash"
})


export default router
